import { API_PATH } from '../../routes/generalPath';

export const ENQUETE_STATUS_PATH = {
  INDEX: API_PATH.ENQUETE_STATUS,
};
